import { modelRequest } from "@stem-sims/nexus"
import { OrgUsersResponse } from "../types/orgUserTypes"

/**
 * Gets the organization users
 */
export function get() : Promise<OrgUsersResponse> {
    return modelRequest.get('/api/organizations/users')
}
